/** Figma footer tagline (node 265-306). */
export const SITE_TAGLINE_LINE_ONE = 'Arvid builds the missing knowledge graph,';
export const SITE_TAGLINE_LINE_TWO = 'for your product.';

const SITE_LEGAL_ENTITY = 'Arvid';

const SITE_MADE_IN = 'Made in Sweden';

export function formatSiteFooterLegal(year: number): string {
  return `© ${year} ${SITE_LEGAL_ENTITY}. All rights reserved. ${SITE_MADE_IN}`;
}
